import React from "react";
import { Modal } from "react-bootstrap";
import logoMalaysia from "../../../../shared/resources/Malaysia_logo_2021.png";
import logoSrilanka from "../../../../shared/resources/insl-logo-1.png";
import logoBosnia from "../../../../shared/resources/ieee-logo-bih.png";
import logoJamaica from "../../../../shared/resources/Jamaika-Color-Flat.png";
import logoIndonesia from "../../../../shared/resources/Indonesia-logo.png";
import { MdClose } from "react-icons/md";
import { Country } from "../../../../shared/constants/Constant";

interface IProps {
  show: boolean;
  country: Country;
  onHide(): void;
}

const Guidelines = (props: IProps) => {
  const getContent = (): any => {
    switch (props.country) {
      case Country.SRI_LANKA:
        return (
          <>
            <span>
              Thank you for your interest to apply for IEEE Innovation Nation
              Sri Lanka 2021 Pre-Accelerator.{" "}
            </span>
            Please make sure you read the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://in.ieee.org/guidelines-srilanka"
            >
              competition rules and guidelines
            </a>{" "}
            before starting the application.
          </>
        );
      case Country.MALAYSIA:
        return (
          <>
            <span>
              Thank you for your interest to apply for IEEE Innovation Nation
              Malaysia 2022 Techno-preneurship Bootcamp.{" "}
            </span>
            Please make sure you read the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://in.ieee.org/guidelines-malaysia"
            >
              competition rules and guidelines
            </a>{" "}
            before starting the application.
          </>
        );
      case Country.INDONESIA:
        return (
          <>
            <span>
              Thank you for your interest to apply for IEEE Innovation Nation
              Indonesia 2021 Techno-preneurship Bootcamp.{" "}
            </span>
            Please make sure you read the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://in.ieee.org/guidelines-indonesia"
            >
              competition rules and guidelines
            </a>{" "}
            before starting the application.
          </>
        );
      case Country.JAMAICA:
        return (
          <>
            <span>
              Thank you for your interest to apply for IEEE Innovation Nation
              Jamaica.{" "}
            </span>
            Please make sure you read the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://in.ieee.org/guidelines-jamaica"
            >
              competition rules and guidelines
            </a>{" "}
            before starting the application.
          </>
        );
      default:
        return (
          <>
            <span>
              Thank you for your interest to apply for IEEE Innovation Nation
              Bosnia & Herzegovina.{" "}
            </span>
            Please make sure you read the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://in.ieee.org/guidelines-bih"
            >
              competition rules and guidelines
            </a>{" "}
            before starting the application.
          </>
        );
    }
  };

  const getImage = (): any => {
    switch (props.country) {
      case Country.SRI_LANKA:
        return <img src={logoSrilanka} alt="" style={{ width: "150px" }} />;
      case Country.MALAYSIA:
        return <img src={logoMalaysia} alt="" style={{ width: "300px" }} />;
      case Country.JAMAICA:
        return <img src={logoJamaica} alt="" style={{ width: "300px" }} />;
      case Country.INDONESIA:
        return <img src={logoIndonesia} alt="" style={{ width: "300px" }} />;
      default:
        return <img src={logoBosnia} alt="" style={{ width: "200px" }} />;
    }
  };

  const getDeadline = () => {
    switch (props.country) {
      case Country.SRI_LANKA:
        return <p>Deadline for application submission: 25th August 2021</p>;
      case Country.BOSNIA:
        return <p>Deadline for application submission: 31st August 2020</p>;
      case Country.JAMAICA:
        return <p>Deadline for application submission: 30th October 2020</p>;
      case Country.INDONESIA:
        return <p>Deadline for application submission: 31st October 2021</p>;
      default:
        return <p>Deadline for application submission: 30th September 2022</p>;
    }
  };
  return (
    <Modal
      show={props.show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => props.onHide()}
    >
      <Modal.Body
        className="arrow_box gl-model-body"
        style={{
          backgroundColor: "#eee",
          padding: "50px",
          paddingTop: "30px",
          borderRadius: "10px",
          border: "none",
        }}
      >
        <MdClose className="close-button" onClick={props.onHide} />
        <h1
          className="text-center pb-3 form-label"
          style={{ borderBottom: "solid 2px #00629b" }}
        >
          Guidelines
        </h1>
        <div style={{ fontSize: "14px" }}>
          <p className="text-justify mt-5">{getContent()}</p>
          {getDeadline()}
          <p>
            For more details about the competition structure, visit:{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://in.ieee.org/"
            >
              in.ieee.org
            </a>
          </p>
          <div className="text-center">{getImage()}</div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Guidelines;
